import { render, staticRenderFns } from "./DadosAdministrativos.vue?vue&type=template&id=2a351399&"
import script from "./DadosAdministrativos.vue?vue&type=script&lang=js&"
export * from "./DadosAdministrativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports